import type { FaireProductEntity } from "../../entity_types/product";

export const p_kwpste5e82: FaireProductEntity = {
  token: "p_kwpste5e82",
  type: "product",
  name: "Large Capacity Soft Tote Bag For Women, Minimalist Shoulder Bag",
  brandToken: "b_n77n5vays8",
  brandName: "kycozy",
  imageUrl:
    "https://cdn.faire.com/fastly/8fd83d65e1dfe09678098ff3717d74013b2bdab64127c6757b0dea1f3af0d9f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f46d986db35c70a2b6fb0825a65e899a9282e8116f31f4cbb00cd488bf9c2936.jpeg",
    "https://cdn.faire.com/fastly/2a97d82428b441fa87068add7a8417aa762f7e75eab65e557245988aebf98f76.jpeg",
    "https://cdn.faire.com/fastly/467725e2ddbebfab411e583a1e82de4057baccb17fe781e0b19588a0e3fb44e5.jpeg",
    "https://cdn.faire.com/fastly/18eeb15efe947807a0761f6f3d4460fc3bd53a3fe34ae7f8255acc72f0fdb3cf.jpeg",
  ],
  priceDollars: 12.99,
  description:
    "Our Large Capacity Soft Tote Bag for Women is a minimalist shoulder bag from Kycozy, a brand that started as a tiny online shop and has grown into a fashion brand with 12 brick-and-mortar locations across the Southeast. This shoulder bag is a versatile accessory that transitions from day to night, making it an ideal choice for various occasions. Trust Kycozy to bring you designs that echo your style and spirit.",
  tags: [],
  msrpDollars: 25.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:03.791Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
